export default "__VITE_ASSET__CxOE3iH$__"